import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useApi, img } from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { Reveal, ZoomImg } from "@/components/site/Reveal";
import { WhatsAppIcon } from "@/components/site/SocialIcons";

const SLUG = "big-sky-stables-equestrian-facility-for-sale";

export const StablesSpotlight = () => {
  const { t, L, to } = useLang();
  const { data: l } = useApi(`/listings/${SLUG}`);
  if (!l) return null;
  const href = to(`/${l.slug}`);
  return (
    <section className="container-x py-20 sm:py-24" data-testid="home-stables">
      <Reveal className="relative overflow-hidden rounded-3xl bg-forest text-white">
        <ZoomImg src={img(l.cover_image)} alt={L(l, "title")} loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/65 via-black/30 to-transparent" />
        <div className="relative max-w-2xl p-8 [text-shadow:0_2px_12px_rgba(0,0,0,0.55)] sm:p-12 lg:p-16">
          <p className="text-xs font-bold uppercase tracking-wider text-white/75">{t("home.stablesEyebrow")}</p>
          <h2 className="mt-3 text-4xl font-black tracking-tight sm:text-5xl">{t("home.stablesTitle")}</h2>
          <p className="mt-3 font-display text-3xl font-black" data-testid="home-stables-price">{L(l, "price_label")}</p>
          <p className="mt-4 text-sm font-medium leading-relaxed text-white/90 md:text-base">{L(l, "tagline")}</p>
          <ul className="mt-6 flex flex-wrap gap-2" data-testid="home-stables-specs">
            {(L(l, "specs") || []).map((s) => <li key={s} className="rounded-full border border-white/30 bg-white/10 px-3 py-1 text-xs font-bold backdrop-blur-md">{s}</li>)}
          </ul>
          <div className="mt-8 flex flex-wrap items-center gap-3 [text-shadow:none]">
            <Link to={href} className="inline-flex items-center gap-2 rounded-full bg-white px-6 py-3 text-sm font-bold text-forest transition-transform duration-200 hover:-translate-y-0.5" data-testid="home-stables-view">{t("home.stablesView")} <ArrowRight className="h-4 w-4" /></Link>
            {l.external_url && <a href={l.external_url} target="_blank" rel="noreferrer" className="inline-flex items-center gap-2 rounded-full bg-[#25D366] px-6 py-3 text-sm font-bold text-white transition-transform duration-200 hover:-translate-y-0.5" data-testid="home-stables-whatsapp"><WhatsAppIcon className="h-4 w-4" /> {t("home.stablesWa")}</a>}
            <Link to={`${href}#inquire`} className="px-2 py-3 text-sm font-bold text-white underline-offset-4 hover:underline" data-testid="home-stables-request">{t("home.stablesRequest")}</Link>
          </div>
        </div>
      </Reveal>
    </section>
  );
};
